const EARTH_RADIUS_M = 6_371_000;

function toRadians(deg: number): number {
    return (deg * Math.PI) / 180;
}

/**
 * Haversine distance between two (lat, lon) pairs.
 * @returns distance in metres
 */
export function haversineDistanceMetres(
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number,
): number {
    const dLat = toRadians(lat2 - lat1);
    const dLon = toRadians(lon2 - lon1);
    const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(dLon / 2) ** 2;
    return EARTH_RADIUS_M * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
